<div
  class="claroProgressBar_outer"
  [style.width]="width"
  [style.height]="height"
  [style.background-color]="backgroundColor"
>
  <div
    class="claroProgressBar_fill"
    [style.width.%]="value"
    [style.background-color]="fillColor"
  ></div>
</div>
